import * as z from 'zod';

export const SupportHours = z.object({
  line1: z.string().optional(),
  line2: z.string().optional(),
  line3: z.string().optional(),
});
export type SupportHours = z.infer<typeof SupportHours>;
